module.exports = __webpack_public_path__ + "img/u_analytics.fe9897cb.svg";